import { gql } from '@apollo/client'

export type MezzanineRawAvailability =
  | 'AVAILABLE'
  | 'GLACIER_NEEDS_RESTORE'
  | 'GLACIER_RESTORING'
  | 'NOT_FOUND'
  | 'UNSUPPORTED_PROVIDER'

export type MezzanineRestoreStatus = 'PENDING_RESTORE' | 'READY' | 'EXPIRED' | 'FAILED'

export type MediaAssetMezzanineRaw = {
  s3Uri?: string | null
  fileName?: string | null
  availability: MezzanineRawAvailability
  restoreStatus?: MezzanineRestoreStatus | null
  restoreRequestedAt?: string | null
  restoreReadyAt?: string | null
  restoreExpiresAt?: string | null
}

export type MediaAssetMezzanineDownload = {
  mediaAssetId: string
  s3Uri?: string | null
  fileName?: string | null
  downloadUrl: string
  downloadUrlExpiresAt: string
}

export const MEDIA_ASSET_MEZZANINE_RAW = gql`
  query MediaAssetMezzanineRaw($mediaAssetId: ID!) {
    mediaAssetMezzanineRaw(mediaAssetId: $mediaAssetId) {
      s3Uri
      fileName
      availability
      restoreStatus
      restoreRequestedAt
      restoreReadyAt
      restoreExpiresAt
    }
  }
`

export const MEDIA_ASSET_REQUEST_MEZZANINE_RESTORE = gql`
  mutation MediaAssetRequestMezzanineRestore($mediaAssetId: ID!) {
    mediaAssetRequestMezzanineRestore(mediaAssetId: $mediaAssetId) {
      s3Uri
      fileName
      availability
      restoreStatus
      restoreRequestedAt
      restoreReadyAt
      restoreExpiresAt
    }
  }
`

export const MEDIA_ASSET_MEZZANINE_DOWNLOAD = gql`
  query MediaAssetMezzanineDownload($mediaAssetId: ID!) {
    mediaAssetMezzanineDownload(mediaAssetId: $mediaAssetId) {
      mediaAssetId
      s3Uri
      fileName
      downloadUrl
      downloadUrlExpiresAt
    }
  }
`
